export const EVENT_YEAR_FILTER_UPCOMING_ALL = "upcoming_all";
export const EVENT_YEAR_FILTER_PAST_ALL = "past_all";

/** Earliest calendar year shown in the Past section (Legacy parity). */
export const EVENT_YEAR_PAST_FLOOR = 2021;

export type EventYearFilterOption = {
  id: string;
  name: string;
  disabled?: boolean;
};

/**
 * Legacy-style year filter:
 * Upcoming - all, next year, current year (upcoming)
 * Past - all, current year (past), then prior full years down to 2021.
 */
/** Whether a year dropdown id implies past or upcoming events (for quick-filter sync). */
export function getEventYearFilterTimingHint(
  yearId: string | null | undefined,
): "past" | "upcoming" | null {
  if (yearId == null || String(yearId).trim() === "") {
    return null;
  }
  const trimmed = String(yearId).trim();
  if (
    trimmed === EVENT_YEAR_FILTER_UPCOMING_ALL ||
    trimmed.startsWith("next_year_") ||
    trimmed.startsWith("current_year_upcoming_")
  ) {
    return "upcoming";
  }
  if (
    trimmed === EVENT_YEAR_FILTER_PAST_ALL ||
    trimmed.startsWith("current_year_past_") ||
    trimmed.startsWith("previous_year_")
  ) {
    return "past";
  }
  return null;
}

export function getEventYearFilterOptions(
  now: Date = new Date(),
): EventYearFilterOption[] {
  const currentYear = now.getFullYear();
  const nextYear = currentYear + 1;

  const options: EventYearFilterOption[] = [
    { id: EVENT_YEAR_FILTER_UPCOMING_ALL, name: "Upcoming - all" },
    { id: `next_year_${nextYear}`, name: String(nextYear) },
    {
      id: `current_year_upcoming_${currentYear}`,
      name: String(currentYear),
    },
    { id: EVENT_YEAR_FILTER_PAST_ALL, name: "Past - all" },
    { id: `current_year_past_${currentYear}`, name: String(currentYear) },
  ];

  for (let year = currentYear - 1; year >= EVENT_YEAR_PAST_FLOOR; year--) {
    options.push({ id: `previous_year_${year}`, name: String(year) });
  }

  return options;
}
